<div class="contextMenuContainer mainMenu" #mainMenu (insClickOutside)="handleClickOutside()"
  [class.visible]="visible" [ngStyle]="position">
  @if (selectedPm !== undefined) {
    <div>
      @if (selectedPm.category !== 'QR_CODE' && ((selectedPm.category === 'PANORAMIC' && isPermEditPanoramicPm) || (selectedPm.category === 'ADDRESS' && isPermEditAddressPm) ||
        isPermEditPm)) {
        <div class="SubMenuLine outerEntry" (click)="editPM()"
          >
          <mat-icon class="lineIcon noStroke" svgIcon="edit.right.click.placemark"></mat-icon>
          Edit placemark
        </div>
      }
      @if (selectedPm.category === 'QR_CODE') {
        <div class="SubMenuLine outerEntry" (click)="printQR()">
          <mat-icon class="lineIcon noStroke" svgIcon="print.right.click.placemark"></mat-icon>
          Print placemark
        </div>
      }
      @if ((selectedPm.category === 'QR_CODE' && isPermDeleteQRCodePm) ||
        (selectedPm.category === 'PANORAMIC' && isPermDeletePanoramicPm) ||
        (selectedPm.category === 'ADDRESS' && isPermDeleteAddressPm) ||
        (isPermDeletePm && !isPmCreatedByChecklistApp)) {
        <div class="SubMenuLine outerEntry" (click)="deletePM()"
          >
          <mat-icon class="lineIcon noStroke" svgIcon="delete.right.click.placemark"></mat-icon>
          Delete placemark
        </div>
      }
      <div class="SubMenuLine outerEntry" (click)="showHistory()">
        <mat-icon class="lineIcon noStroke" svgIcon="history.right.click.placemark"></mat-icon>
        Show history
      </div>
      @if (selectedPm.category !== 'QR_CODE') {
        <div class="SubMenuLine outerEntry" (click)="openDiscussionForPM()">
          <mat-icon class="lineIcon noStroke" svgIcon="discussion.right.click.placemark"></mat-icon>
          Open discussion
        </div>
      }
      @if (eventInfo) {
        <div class="SubMenuLine outerEntry" (click)="placemarkEventInformation()">
          <mat-icon class="lineIcon noStroke" svgIcon="eventinfo.right.click.placemark"></mat-icon>
          Placemark Event Information&nbsp;
        </div>
      }
      @if (isPermCreateAllPM) {
        <div class="SubMenuLine outerEntry subMenuParent" style="position: relative;" appSubmenuPosition [submenu]="submenu">
          <mat-icon class="lineIcon noStroke" svgIcon="add.placemark.submenu"></mat-icon>
          Create at this location&nbsp;
          <mat-icon class="lineIcon noStroke arrowIcon" svgIcon="arrow.right"></mat-icon>
          <div class="contextMenuContainer subMenu" #submenu>
            <ins-placemark-submenu-content (actionClicked)="contextMenuActionClicked();" [isOpen]="visible" [selectedPm]="selectedPm"></ins-placemark-submenu-content>
          </div>
        </div>
      }
    </div>
  } @else {
    <ins-placemark-submenu-content (actionClicked)="contextMenuActionClicked();" [isOpen]="visible"></ins-placemark-submenu-content>
  }
</div>
